import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/api/axios-instance";

export interface TimelineBundle {
  id: string;
  standard_id: string;
  name: string;
  amount: number;
  currency: string;
  status: "ACTIVE" | "INACTIVE";
  released_at: string | null;
  created_at: string;
  session_quantity: number | null;
  payment_page_link: string;
  // # of real users (region-scoped) whose signup falls in this version's cohort
  // window. Present on baseline + experimental; absent on history.
  cohort_size?: number;
}

export interface TimelineOffering {
  standard_id: string;
  name: string;
  session_quantity: number | null;
  currency: string;
  baseline: TimelineBundle | null;
  experimental: TimelineBundle[]; // asc by released_at
  history: TimelineBundle[];
}

export interface PricingTimelineResponse {
  offerings: TimelineOffering[];
}

export async function getPricingTimeline(params: {
  standard_id?: string;
  product_id?: string;
  region?: string;
}): Promise<PricingTimelineResponse> {
  return (await axiosInstance.get("/bundle/pricing-timeline", { params })).data;
}

export function usePricingTimeline(params: {
  standard_id?: string;
  product_id?: string;
  region?: string;
}) {
  return useQuery({
    queryKey: [
      "bundles",
      "pricing-timeline",
      params.standard_id ?? null,
      params.product_id ?? null,
      params.region ?? null,
    ],
    queryFn: () => getPricingTimeline(params),
    enabled: !!(params.standard_id || params.product_id),
  });
}
